import { render } from "./InversionNegocio.vue?vue&type=template&id=0fb3db14&scoped=true"
import script from "./InversionNegocio.vue?vue&type=script&lang=js"
export * from "./InversionNegocio.vue?vue&type=script&lang=js"

import "./InversionNegocio.vue?vue&type=style&index=0&id=0fb3db14&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb3db14"]])

export default __exports__